import React from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminWorkOrderTemplateList from './templates/List';
import AdminWorkOrderRoutesList from './routes/List';

const { TabPane } = Tabs as any;

const AdminWorkOrdersIndex: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const detectActive = (): 'templates' | 'routes' => {
    const p = location.pathname || '';
    if (p.includes('/work-orders/routes')) return 'routes';
    return 'templates';
  };
  const [active, setActive] = React.useState<'templates' | 'routes'>(detectActive());

  React.useEffect(() => { setActive(detectActive()); }, [location.pathname]);

  return (
    <div className="p-4">
      <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>工单系统</div>
      <Tabs type="card" activeKey={active} onChange={(k:string) => {
        setActive(k as any);
        const base = '/dashboard/admin/work-orders';
        if (k === 'templates') navigate(`${base}/templates`);
        if (k === 'routes') navigate(`${base}/routes`);
      }}>
        <TabPane tab="工单模板" key="templates">
          <AdminWorkOrderTemplateList />
        </TabPane>
        <TabPane tab="客户工单路由" key="routes">
          <AdminWorkOrderRoutesList />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default AdminWorkOrdersIndex;


